import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { ALERTS_QUERY_KEY } from "./useAlerts";

type AlertResponse = components["schemas"]["AlertResponse"];

export function useAcknowledgeAlert() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<AlertResponse, Error, string>({
    mutationFn: async (alert_id) => {
      const { data, error } = await client.POST(
        "/api/alerts/{alert_id}/acknowledge",
        {
          params: { path: { alert_id } },
        },
      );
      if (error !== undefined) {
        throw new Error("Failed to acknowledge alert");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ALERTS_QUERY_KEY });
    },
  });
}
